import styled, { css } from "styled-components";
import tw from "twin.macro";

import { IconButton } from "../IconButton";
import { ArrowDownLongIcon, ArrowUpLongIcon, SortGeneralIcon } from "../Icons";
import { List, ListItem, ListItemProps } from "../List";
import { ValueButton } from "../ValueButton";

export const StyledSortWrapper = styled.div`
  ${tw`tw-w-fit`};
`;

StyledSortWrapper.displayName = "StyledSortWrapper";

export const StyledValueButton = styled(ValueButton)`
  ${tw`tw-hidden md:tw-flex tw-items-center`};
`;

StyledValueButton.displayName = "StyledValueButton";

export const StyledIconButton = styled(IconButton)`
  ${tw`tw-flex tw-items-center md:tw-hidden hover:tw-text-primary`};
`;

StyledIconButton.displayName = "StyledIconButton";

export const StyledSortIcon = styled(SortGeneralIcon)`
  ${tw`tw-mt-0`};
`;

StyledSortIcon.displayName = "StyledSortIcon";

export const StyledSortIconDown = styled(ArrowDownLongIcon)`
  ${tw`tw-shrink-0`};
`;

StyledSortIconDown.displayName = "StyledSortIconDown";

export const StyledSortIconUp = styled(ArrowUpLongIcon)`
  ${tw`tw-shrink-0`};
`;

StyledSortIconUp.displayName = "StyledSortIconUp";

export const StyledList = styled(List)`
  ${tw`tw-py-2`};
`;

StyledList.displayName = "StyledList";

interface StyledListItemProps extends ListItemProps {
  $active?: boolean;
}

export const StyledListItem = styled(ListItem)<StyledListItemProps>`
  ${tw`tw-justify-between`};
  svg {
    visibility: hidden;
  }
  &:hover svg {
    fill: var(--color-theme-500);
    visibility: visible;
  }

  ${(props) =>
    props.$active &&
    css`
      ${tw`tw-text-primary`};

      svg {
        fill: var(--color-primary);
        visibility: visible;
      }
      &:hover svg {
        fill: var(--color-primary);
        visibility: visible;
      }
    `}
`;

StyledListItem.displayName = "StyledListItem";

export const StyledListItemName = styled.span`
  ${tw`tw-truncate`};
`;

StyledListItemName.displayName = "StyledListItemName";
